import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

/**
 * Dispatched when consumer receives suggestions from 3S that will eventually
 * be rendered. We need to track the time at which that request was made, so
 * that'll be passed within the action message.
 */
const onReceivedSuggestionsToRender = action(
    'onReceivedSuggestionsToRender',
    (scenarioId: SearchScenarioId, displayedQFRequestTime: Date) => ({
        scenarioId,
        displayedQFRequestTime,
    })
);

export default onReceivedSuggestionsToRender;
